import { DataTypes } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";
import { validateClusterComponentCount } from "./subEquipments";

/**
 * Aggregated view over the chosen sub-equipments (order, leading software
 * version, position toggle). Rendered through a custom preview input supplied by
 * the frontend structure (ClusterComponentsPreview); the schema only registers
 * the field and its data type.
 */
export const subEquipmentsPreview: FieldSchema = {
  name: "subEquipmentsPreview",
  // UI-only aggregate: not a GraphQL field, so exclude it from the schema-derived
  // Selection...
  graphql: { selection: undefined },
  // ...and not part of the cluster mutation input, so strip it from the outgoing
  // payload.
  dataTransform: {
    toGraphql: undefined,
  },
  data: {
    type: DataTypes.OBJECT,
    active: true,
  },
  // The preview has no value of its own to validate; it mirrors the picker's rule so the
  // shortfall is reported on the step the user is looking at.
  validation: {
    custom: {
      getter: validateClusterComponentCount,
      fields: ["subEquipments"],
    },
  },
};
